import { Group, Stack, Text, Tooltip } from "@mantine/core";

/**
 * The two type roles the detail rail is allowed to use.
 *
 * The rail had grown three competing container conventions — some sections were bordered Papers,
 * some were bare divs with an uppercase label — and values ran at `sm` and `xs` interchangeably.
 * With nothing distinguishing a group from its neighbour, six stacked panels read as one
 * undifferentiated list. Everything here goes through RailSection (a labelled group) and RailRow
 * (a label→value pair); a section that needs to shout is a deliberate exception, not a default.
 */
export function RailSection({ label, tooltip, right, children, ...props }) {
  const heading = (
    <Text
      fz="xs"
      fw={700}
      tt="uppercase"
      c="dimmed"
      style={{ letterSpacing: "0.04em" }}
    >
      {label}
    </Text>
  );

  return (
    <Stack gap={8} {...props}>
      {label && (
        <Group justify="space-between" gap="xs" wrap="nowrap">
          {tooltip ? (
            <Tooltip label={tooltip} position="left" withArrow multiline w={260}>
              {heading}
            </Tooltip>
          ) : (
            heading
          )}
          {right}
        </Group>
      )}
      {children}
    </Stack>
  );
}

/**
 * A label→value pair. The label column is fixed so values line up down the rail — the previous
 * free-form `Group`s were what made the config panel read as unrelated lines rather than a table.
 */
export function RailRow({ label, children, align = "center" }) {
  return (
    <Group gap="xs" wrap="nowrap" align={align === "top" ? "flex-start" : "center"}>
      <Text fz="xs" c="dimmed" w={86} style={{ flexShrink: 0 }}>
        {label}
      </Text>
      <Text
        component="div"
        fz="sm"
        style={{ minWidth: 0, wordBreak: "break-word" }}
      >
        {children}
      </Text>
    </Group>
  );
}
